import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const ButtonsContainer = styled.div`
  width: 50%;
  max-width: 26rem;
  position: relative;
  padding: 0 0 0 1.5rem;
`;

export const RichTextWrapper = styled.article`
  position: relative;
  margin-left: auto;
  padding: 2.5rem 0;
  background: ${({ theme }) => theme.colors.white};

  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 2.5rem 1.5rem;
  }
`